import React from "react";
import TableText from "@/components/table/TableText";
import getJson, { numConvert, calculation } from "@/method";
const totalIndex = [8];

export default (data, date) => {
    ['rev', 'rooms'].forEach(name => {
        data[8][name] = data.reduce((a, b, i) => i < 8 ? a + numConvert(b[name]) : a, 0).toFixed(2);
    });

    data.forEach((item, i) => {
        data[i].adr = calculation(item.rev, item.rooms);
        data[i].mix = calculation(item.rooms, data[8].rooms, 4);
    });
    return data
}


export const columns = (onChange, date, print) => {
    return [
        {
            title: ``,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Price Level`,
            dataIndex: 'rate',
            key: 'rate',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['rate'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                    name: "rate",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_1_5_new"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Rooms nights`,
            dataIndex: 'rooms',
            key: 'rooms',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['rooms'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                    name: "rooms",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_1_5_new"
                    }
                };

                return <TableText data={props} />
            }
        },
        {
            title: `Room Revenue`,
            dataIndex: 'rev',
            key: 'rev',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['rev'];
                const props = {
                    text,
                    index,
                    type: !totalIndex.includes(index) && !print ? 'inputNumber' : 'number',
                    name: "rev",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_1_5_new"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `ADR`,
            dataIndex: 'adr',
            key: 'adr',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['adr'];
                const props = {
                    text,
                    index,
                    type: 'number',
                    name: "adr",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_1_5_new"
                    }
                };
                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Mix%`,
            dataIndex: 'mix',
            key: 'mix',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['mix'];
                const props = {
                    text,
                    index,
                    type: 'percent',
                    name: "mix",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_1_5_new"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-1/4-1-5/compute.js